var RewardCalculator = Backbone.View.extend({
  events: {
    "click [data-reward-calculator-apply]": "applyReward",
    "keyup [data-reward-calculator-amount]": "toggleApplyUpdate"
  },

  initialize: function() {
    this.settings = {
      url: null,
      isInitialized: false
    };

    if (this.$el.data("settings")) {
      this.settings = this.settings = $.extend(
        true,
        this.settings,
        this.$el.data("settings")
      );
    }
  },

  toggleApplyUpdate: function() {
    this.$("[data-reward-calculator-apply]").removeAttr("disabled");

    $('[data-form-section-validate="' + this.settings.thread + '"]').attr(
      "disabled",
      true
    );
  },

  applyReward: function() {
    var data = $('[data-component="form"]').serializeJSON();

    var sendData = {
      reward_amount: data.reward_amount
    };

    Backbone.Events.trigger("loadingSplashOn");

    window.location = this.settings.url + "?" + $.param(sendData);
  }
});

module.exports = RewardCalculator;
